import React from 'react';
import EmptyState from './EmptyState';

interface VisitEmptyStateProps {
  onViewVenues?: () => void;
  className?: string;
}

const VisitEmptyState: React.FC<VisitEmptyStateProps> = ({ onViewVenues, className }) => {
  const visitIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="8.5" cy="7" r="4"/>
      <path d="M20 8v6"/>
      <path d="M23 11h-6"/>
    </svg>
  );

  return (
    <EmptyState
      icon={visitIcon}
      title="No Visits Yet"
      description="You'll see visit data and customer insights here once your first user checks in. Make sure your venue is set up and users can access your check-in flow."
      action={onViewVenues ? {
        label: "Manage Venues",
        onClick: onViewVenues,
        variant: "secondary"
      } : undefined}
      className={className}
    />
  );
};

export default VisitEmptyState;
